import React from 'react';

import styled from 'styled-components';

import { useCommunityAdminContext } from './CommunityAdminContextProvider';

const Container = styled.div`
  display: flex;
  font-size: 20px;
  color: var(--text-primary);
`;

const CommunityAdminHeader = () => {
  const { communityId } = useCommunityAdminContext();

  return <Container>{communityId ? 'Edit' : 'Add'} Community</Container>;
};

export default CommunityAdminHeader;
